// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA-xaLu114PA3YgikOobYVAirWqQVTR0fc",
  authDomain: "netgpt-663c9.firebaseapp.com",
  projectId: "netgpt-663c9",
  storageBucket: "netgpt-663c9.firebasestorage.app",
  messagingSenderId: "804391627897",
  appId: "1:804391627897:web:5832ed332df65db904f8a8",
  measurementId: "G-YRLKFV5GN0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth();